import { render, staticRenderFns } from "./NewCurrentForm.vue?vue&type=template&id=66af4acf"
import script from "./NewCurrentForm.vue?vue&type=script&lang=js"
export * from "./NewCurrentForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports